// 协议签署相关的
import fetch from '../axios/fetch'
import store from '@/store'
import Axios from 'axios'
import { timeFormat as dateFormat } from '../timeFormat/index'
import { checkBrowser } from '@/plugin/channel/setUserChannel'

const RESOURCES_URL_OBJ = {
  'development': '/newmail-resources',
  'test': '/weixin/newmail-api',
  'release': '/newmail-resources/release',
  'production': '/newmail-resources'
}

const env = process.env.VUE_APP_NODE_ENV
export const RESOURCES_URL = RESOURCES_URL_OBJ[env]

// contractId的类型 privacy:隐私声明 member:会员协议
const typeMap = {
  privacy: env === 'production' ? 'bd49391b80c747e89203dcc4e13420bb' : 'a6f9bfe3b7334e6d8f19c5024e85dcbd',
  member: env === 'production' ? '' : ''
}

const timeoutNum = 8000

// 缓存管理工具 -- 处理当日
export const agreementCache = {
  getCache () {
    const cache = localStorage.getItem('agreementCache')
    return cache ? JSON.parse(cache) : null
  },

  setCache (status) {
    const cacheData = {
      status,
      lastCheckDate: dateFormat(new Date(), 'yyyy-MM-dd')
    }
    localStorage.setItem('agreementCache', JSON.stringify(cacheData))
  },

  // 可用于0点自动清除缓存（选）
  clearCache () {
    localStorage.removeItem('agreementCache')
  },

  updateCache (type, status) {
    const cache = this.getCache() || { status: {} }
    cache.status[type] = status
    this.setCache(cache.status)
  },

  // 判断缓存有效性 是否当天调用过
  isCacheValid () {
    const cache = this.getCache()
    if (!cache) return false
    // const today = new Date().toISOString().split('T')[0]
    const today = dateFormat(new Date(), 'yyyy-MM-dd')
    return cache.lastCheckDate === today
  }
}

/**
 * 签署协议（失败自动更新缓存）
 * @param {Object} params - 包含协议类型和签署数据
 *   @property {string} type - 协议类型（'privacy'|'member'）
 *   @property {String[]} versionIdList - 版本ID列表
 * @returns {Promise<Object>}
 */
export async function signAgreement (params) {
  const type = params.type
  delete params.type
  try {
    // 添加请求超时控制（x秒）
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), timeoutNum)
    let { data = '' } = await fetch.post('/contract/signAgreement', params)
    clearTimeout(timeoutId)
    agreementCache.updateCache(type, true)
    return data
  } catch (error) {
    console.error('[协议签署] 失败:', error)
    // 降级方案：更新缓存为已签署（防止阻塞流程）
    agreementCache.updateCache(type, true)
    return true
  }
}

/**
 * 判断是否签署最新协议
 * @param params {
 *   @property types: AgreementType[], // 必填，协议类型数组
 *   [key: string]: any      // 其他透传参数
 * }
 * @returns {Promise<Record<string, boolean>>} 各协议类型对应的签署状态
 *  输入示例{ types: ['privacy', 'member'], userId: '12345' }
 *  输出示例: { privacy: true, member: false }
 */
export async function isSignedLatestAgreement (params) {
  console.log('判断签署')
  const types = params.types
  delete params.types
  // 1. 检查缓存有效性
  if (agreementCache.isCacheValid()) {
    const cachedData = agreementCache.getCache()
    // 返回缓存中存在的类型状态（未缓存类型默认返回true）
    return types.reduce((acc, type) => {
      acc[type] = cachedData.status[type] !== undefined
        ? cachedData.status[type]
        : true
      return acc
    }, {})
  }

  // 2. 无有效缓存时调用API
  try {
    const contractIdList = types.map(type => typeMap[type]).filter(Boolean)

    // 添加请求超时控制（x秒）
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), timeoutNum)

    params['contractIdList'] = contractIdList
    let { data = '' } = await fetch.post('/contract/isSignedLatestAgreement', params)
    clearTimeout(timeoutId)
    if (data && data.code === '000000') {
      const resultList = data.info || []
      const resultStatus = types.reduce((acc, type) => {
        const targetId = typeMap[type]
        const targetResult = resultList.find(item => item.contractId === targetId)
        acc[type] = targetResult ? targetResult.result : true
        return acc
      }, {})
      // 更新缓存
      agreementCache.setCache(resultStatus)

      return resultStatus
    }
    // 3. 接口异常
    const fallbackStatus = types.reduce((acc, type) => {
      acc[type] = true
      return acc
    }, {})

    // 设置降级缓存（有效期到当日结束）
    agreementCache.setCache(fallbackStatus)
    return fallbackStatus
  } catch (error) {
    console.error('[协议检查] 接口请求失败:', error)
    // 4. 接口失败 降级处理（默认true防止阻塞流程）
    const fallbackStatus = types.reduce((acc, type) => {
      acc[type] = true
      return acc
    }, {})

    // 设置降级缓存（有效期到当日结束）
    agreementCache.setCache(fallbackStatus)
    return fallbackStatus
  }
}

/**
 * 查询历史协议数据List
 */
export async function getVersionList (params) {
  params['contractId'] = typeMap[params.type]
  delete params.type
  let { data = '' } = await fetch.post('/contract/versionList', params)
  if (data && data.code === '000000') {
    return data.info
  } else {
    return []
  }
}

/**
 * 查询最新版本的隐私声明协议数据
 */
export async function getVersionLatest (type = '') {
  const cloudUrl = env === 'production' ? 'https://ec.ems.com.cn/ecro' : 'https://ecuat.ems.com.cn/object'
  const time = env === 'production' ? dateFormat(new Date(), 'yyyyMMdd') : Date.now()
  const latestUrl = `${cloudUrl}/jg/contract/${typeMap[type]}.json?_t=${time}`
  const { data } = await Axios(latestUrl)
  console.log('当前查询到的隐私声明协议数据；；', data)
  return data
}

/**
 * @description: 获取所有协议数据
 * @return {*}
 */
export async function getAllProtocolJson () {
  const { data } = await Axios(`${RESOURCES_URL}/json/protocols.json?t=${Date.now()}`)
  // 查询会员协议
  const { data: memberData } = await Axios(`https://${process.env.VUE_APP_NODE_ENV === 'production' ? 'ec.ems.com.cn' : 'ecuat.ems.com.cn'}/ecr-auz-web/queryContentList/1?t=${Date.now()}`)
  data.membership.title = memberData.info ? memberData.info[0].name : '会员协议'
  data.membership.content = `<div style="font-size:12px;word-wrap:break-word">${memberData.info[0].content}</div>`
  const privacyInfo = await getVersionLatest('privacy')
  const privacyStatement = {
    // title: privacyInfo.name,
    title: '隐私声明', // 需要固定标题
    ...privacyInfo
  }
  privacyStatement.content = privacyStatement.content.replace(/font-size\s*:\s*[^;"]+;?/gi, '')
  privacyStatement.content = `<div style="font-size:12px;word-wrap:break-word">${privacyStatement.content}</div>`
  data.privacyStatement = privacyStatement
  const { huaweiService, domesticService, internationalService, sdkInformationList } = data
  const channel = checkBrowser()
  const protocolArray = [
    { noticeTitle: domesticService.title, noticeContent: ['HWQUICK', 'HWMEETIME'].includes(channel) ? huaweiService.content : data.domesticService.content },
    { noticeTitle: internationalService.title, noticeContent: internationalService.content },
    // 隐私声明
    { noticeTitle: data.privacyStatement.title, noticeContent: data.privacyStatement.content, ...privacyInfo },
    // 会员协议
    { noticeTitle: data.membership.title, noticeContent: data.membership.content },
    { noticeTitle: sdkInformationList.title, noticeContent: sdkInformationList.content }
  ]
  console.log('协议列表的内容protocolArray；；', protocolArray)
  console.log(data)
  store.commit('protocol/setProtocols', protocolArray || {})
  return protocolArray
}

/**
 *@description: 在隐私声明更新提示弹窗中点击取消并退出触发
 */
export function handleExit () {
  console.log('取消并退出了')
}
